const RECOMMENDED_DEVICE_LABEL_TERMS = ['jabra', 'speak'];

export function matchesRecommendedDevice(label: string): boolean {
  const lowerCaseLabel = label.toLowerCase();
  return RECOMMENDED_DEVICE_LABEL_TERMS.every((term) =>
    lowerCaseLabel.includes(term.toLowerCase())
  );
}
